import { render, staticRenderFns } from "./EditPageGen.vue?vue&type=template&id=e18dd82c&"
import script from "./EditPageGen.vue?vue&type=script&lang=js&"
export * from "./EditPageGen.vue?vue&type=script&lang=js&"
import style0 from "./EditPageGen.vue?vue&type=style&index=0&id=e18dd82c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports